import { memo } from "react";
import SocialLogin from "react-social-login";

const SocialButton = memo((props: any) => {
  return (
    <button onClick={props.triggerLogin} {...props}>
      {props.children}
    </button>
  );
});

export default SocialLogin(SocialButton);
